import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import { notifyError, notifySuccess } from "utils/toast";
import MinDurationservices from "services/MinDurationServices";


const useMinDuration = (id) => {
    const { isDrawerOpen, closeDrawer, setIsUpdate } =
        useContext(SidebarContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [NewsUrl, setNewsUrl] = useState("");
    const {
        register,
        handleSubmit,
        setValue,
        reset,
        formState: { errors },
    } = useForm();
    useEffect(() => {
        if (!id) {
            reset();
            setNewsUrl("");
            return;
        }
        const fetchMInduration = async () => {
            try {
                const res = await MinDurationservices.getMinDurationByid(id);
                if (res?.data) {
                    setValue("name", res.data.name);
                    setValue("min_booking_minutes", res.data.min_booking_minutes);
                }
            } catch (error) {
                notifyError("Failed to load min Duration data");
            }
        };


        fetchMInduration();
    }, [id, setValue]);



    const onSubmit = async (data) => {

        try {
            setIsSubmitting(true);

            const DurationData = {
                name: data.name,
                min_booking_minutes: data.min_booking_minutes

            };

            if (id) {
                await MinDurationservices.updateminDuration(id, DurationData);
                notifySuccess("Min Duration submitted Succesfully")
            } 
            setIsUpdate(true);
            closeDrawer();
            reset();
        } catch (error) {
            notifyError(error?.response?.data?.message || "Something went wrong");
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (!isDrawerOpen) {
            reset();
            setNewsUrl("");


        }
    }, [isDrawerOpen, reset]);

    return {
        register,
        handleSubmit,
        onSubmit,
        errors,
        isSubmitting,
        setValue,
        NewsUrl,
        setNewsUrl

    };
};

export default useMinDuration;
